// extracted by mini-css-extract-plugin
export default {"reviewTextarea":"ReviewTextarea_reviewTextarea__kdhyK","textLength":"ReviewTextarea_textLength__MjnUk"};